import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "print",
  "use": "print-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"print\"><path d=\"M17 5h-1V0H4v5H3C1.34 5 0 6.34 0 8v6h4v4h12v-4h4V8c0-1.66-1.34-3-3-3ZM6 2h8v3H6V2Zm8 12v2H6v-4h8v2Zm2-2v-2H4v2H2V8c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol